(function () {
  'use strict';
  if (window.__wbCheckoutClick || window.Shopify?.designMode) return;
  window.__wbCheckoutClick = true;

  const scopeSelector = '[data-wb-checkout-scope]';
  const validScopes = new Set(['cart_page', 'cart_drawer']);
  const buttonScopes = {
    checkout: 'cart_page',
    'CartDrawer-Checkout': 'cart_drawer'
  };
  let loadRequested = false;

  function analyticsAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return typeof privacy?.analyticsProcessingAllowed === 'function'
      && privacy.analyticsProcessingAllowed() === true;
  }

  function prepare(event) {
    try {
      if (loadRequested) return;
      if (event && ['focusin', 'pointerover', 'touchstart'].includes(event.type)
          && !(event.target instanceof Element && event.target.closest(scopeSelector))) return;
      if (!analyticsAllowed()) return;
      const hasCartEntry = Array.from(document.querySelectorAll(scopeSelector))
        .some((node) => node.matches('button[name="checkout"]')
          && Object.prototype.hasOwnProperty.call(buttonScopes, node.id)
          && buttonScopes[node.id] === node.dataset.wbCheckoutScope
          && node.dataset.wbCheckoutEnabled === 'true'
          && !node.matches(':disabled')
          && node.getAttribute('aria-disabled') !== 'true');
      if (hasCartEntry && typeof window.WBMeasurement?.ensureLoaded === 'function') {
        window.WBMeasurement.ensureLoaded();
        loadRequested = true;
      }
    } catch (_) { /* Tracking must never block shopping. */ }
  }

  const attempts = new Map();

  function checkoutEntry(event) {
    const entry = event.composedPath().find((node) =>
      node instanceof Element
      && node.matches('button[name="checkout"][data-wb-checkout-button-type="standard"]')
      && Object.prototype.hasOwnProperty.call(buttonScopes, node.id));
    if (!entry) return null;

    const scope = entry.closest(scopeSelector);
    if (!scope || !validScopes.has(scope.dataset.wbCheckoutScope)
        || buttonScopes[entry.id] !== scope.dataset.wbCheckoutScope
        || scope.dataset.wbCheckoutEnabled !== 'true'
        || entry.matches(':disabled') || entry.hasAttribute('disabled')
        || entry.getAttribute('aria-disabled') === 'true'
        || entry.closest('[inert]')) return null;
    return entry;
  }

  function beginAttempt(entry, kind) {
    const attempt = { kind, touchSeen: false, sent: false };
    attempts.set(buttonScopes[entry.id], attempt);
    return attempt;
  }

  function emitOnce(attempt) {
    if (attempt.sent || !analyticsAllowed()) return;
    prepare();
    window.dataLayer = window.dataLayer || [];
    if (typeof window.dataLayer.push !== 'function') return;

    // Mark before push: downstream callbacks must not send this attempt twice.
    attempt.sent = true;
    window.dataLayer.push({
      event: 'checkout_click',
      checkout_button_type: 'standard'
    });
  }

  function onPointerDown(event) {
    if (!event.isTrusted || event.button !== 0
        || event.isPrimary === false || !analyticsAllowed()) return;
    const entry = checkoutEntry(event);
    if (entry) beginAttempt(entry, event.pointerType || 'mouse');
  }

  function onTouchStart(event) {
    if (!event.isTrusted || event.touches.length !== 1
        || !analyticsAllowed()) return;
    const entry = checkoutEntry(event);
    if (!entry) return;

    let attempt = attempts.get(buttonScopes[entry.id]);
    if (!attempt || attempt.kind !== 'touch' || attempt.touchSeen) {
      attempt = beginAttempt(entry, 'touch');
    }
    attempt.touchSeen = true;

    // Observed BOGOS binding: checkout starts on touchstart.
    if (window.FGSECOMAPP && entry.hasAttribute('sca_handle_checkout')) {
      emitOnce(attempt);
    }
  }

  function onClick(event) {
    if (!event.isTrusted || !analyticsAllowed()) return;
    const entry = checkoutEntry(event);
    if (!entry) return;

    const key = buttonScopes[entry.id];
    const attempt = event.detail === 0
      ? beginAttempt(entry, 'keyboard')
      : attempts.get(key) || beginAttempt(entry, 'click');
    emitOnce(attempt);
    attempts.delete(key);
  }

  function safe(handler) {
    return (event) => {
      try { handler(event); } catch (_) { /* Never block checkout. */ }
    };
  }

  // Window capture runs before BOGOS's button handlers.
  window.addEventListener('pointerdown', safe(onPointerDown),
    { capture: true, passive: true });
  window.addEventListener('touchstart', safe(onTouchStart),
    { capture: true, passive: true });
  window.addEventListener('click', safe(onClick),
    { capture: true, passive: true });

  window.addEventListener('pageshow', () => {
    attempts.clear();
    prepare();
  });
  document.addEventListener('visitorConsentCollected', prepare);
  document.addEventListener('shopify:section:load', prepare);
  document.addEventListener('focusin', prepare, { passive: true });
  document.addEventListener('pointerover', prepare, { passive: true });
  document.addEventListener('touchstart', prepare, { passive: true });

  function boot() {
    prepare();
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => requestAnimationFrame(prepare));
      }
    } catch (_) { /* Optional cart integration must not block tracking setup. */ }
    try {
      if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.2' }],
          (error) => { if (!error) prepare(); }
        );
      }
    } catch (_) { /* Missing privacy permission skips tracking, never checkout. */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
